


























































import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class GenreTracks extends Vue {
    loader = true

    get tracks () {
        return this.$store.getters['trackModule/getTopTracks']? this.$store.getters['trackModule/getTopTracks']: []
    }

    get audio () {
        return this.$store.getters['getAudio']
    }

    get current () {
        return this.$store.getters['getCurrent']
    }

    convertTime (secs: any) {
        const min = Math.floor(secs / 60);
        const sec = secs % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    playSong (track: any, queue: any) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }

    mounted () {
        window.scrollTo(0,0);
        this.$store.dispatch('trackModule/fetchTopTracks', 40).then((response: any) => {
           this.loader = false
        })
    }
}
